@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'data processing'"
        [moduleType]="moduleType"
        [idProp]="'Guid'"
        [permissions]="permissions"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        (onDblClick)="openDetail($event)"
        (onAddClick)="add()"
    >
    </cerrix-workspace>
}
